import { GlAccordion, GlAccordionItem, GlBadge, GlSafeHtmlDirective } from '@gitlab/ui';
import { translate } from '../../../../../utils/i18n';
import PreBlock from './pre_block';
import ToolParamsJsonView from './tool_params_json_view';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const projectLabel = translate('BaseToolParams.projectLabel', 'Project');
const groupLabel = translate('BaseToolParams.groupLabel', 'Group');
const issueLabel = translate('BaseToolParams.issueLabel', 'Issue');
const mergeRequestLabel = translate('BaseToolParams.mergeRequestLabel', 'Merge request');
const workItemLabel = translate('BaseToolParams.workItemLabel', 'Work item');
const epicLabel = translate('BaseToolParams.epicLabel', 'Epic');
const sourceBranchLabel = translate('BaseToolParams.sourceBranchLabel', 'Source branch');
const targetBranchLabel = translate('BaseToolParams.targetBranchLabel', 'Target branch');
const startDateLabel = translate('BaseToolParams.startDateLabel', 'Start date');
const dueDateLabel = translate('BaseToolParams.dueDateLabel', 'Due date');
const healthStatusLabel = translate('BaseToolParams.healthStatusLabel', 'Health status');
const labelsLabel = translate('BaseToolParams.labelsLabel', 'Labels');
const vulnerabilityLabel = translate('BaseToolParams.vulnerabilityLabel', 'Vulnerability');
const dismissalReasonLabel = translate('BaseToolParams.dismissalReasonLabel', 'Dismissal reason');
const stateLabel = translate('BaseToolParams.stateLabel', 'State');
const confidentialLabel = translate('BaseToolParams.confidentialLabel', 'Confidential');
const typeLabel = translate('BaseToolParams.typeLabel', 'Type');
const metadataProperties = {
  projectId: {
    icon: 'project',
    label: projectLabel
  },
  projectPath: {
    icon: 'project',
    label: projectLabel
  },
  projectFullPath: {
    icon: 'project',
    label: projectLabel
  },
  groupId: {
    icon: 'group',
    label: groupLabel
  },
  groupPath: {
    icon: 'group',
    label: groupLabel
  },
  issueId: {
    icon: 'issues',
    label: issueLabel
  },
  issueIid: {
    icon: 'issues',
    label: issueLabel
  },
  mergeRequestId: {
    icon: 'merge-request',
    label: mergeRequestLabel
  },
  mergeRequestIid: {
    icon: 'merge-request',
    label: mergeRequestLabel
  },
  workItemIid: {
    icon: 'work-items',
    label: workItemLabel
  },
  epicIid: {
    icon: 'epics',
    label: epicLabel
  },
  sourceBranch: {
    icon: 'branch',
    label: sourceBranchLabel
  },
  targetBranch: {
    icon: 'branch',
    label: targetBranchLabel
  },
  url: {
    icon: 'external-link',
    type: 'url'
  },
  startDate: {
    icon: 'calendar',
    label: startDateLabel
  },
  dueDate: {
    icon: 'calendar',
    label: dueDateLabel
  },
  healthStatus: {
    icon: 'status-health',
    label: healthStatusLabel
  },
  state: {
    label: stateLabel,
    icon: value => value === 'opened' ? 'status_open' : 'status_closed'
  },
  labels: {
    icon: 'labels',
    label: labelsLabel
  },
  addLabelIds: {
    icon: 'labels',
    label: labelsLabel
  },
  confidential: {
    icon: value => value ? 'eye-slash' : 'eye',
    label: confidentialLabel
  },
  typeName: {
    icon: value => `work-item-${value.toLowerCase()}`,
    label: typeLabel
  },
  vulnerabilityId: {
    label: vulnerabilityLabel
  },
  dismissalReason: {
    icon: 'information',
    label: dismissalReasonLabel
  }
};
var script = {
  name: 'BaseToolParams',
  components: {
    GlAccordion,
    GlAccordionItem,
    GlBadge,
    PreBlock,
    ToolParamsJsonView
  },
  directives: {
    SafeHtml: GlSafeHtmlDirective
  },
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    toolParams: {
      type: Object,
      required: false,
      default: () => {}
    },
    customAccordionTitle: {
      type: String,
      required: false,
      default: ''
    },
    withJsonView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    accordionTitle() {
      return this.customAccordionTitle || this.$options.i18n.DESCRIPTION_ACCORDION_TITLE;
    },
    metadataProperties() {
      const toolParams = this.toolParams || {};
      return Object.entries(metadataProperties).filter(_ref => {
        let [property] = _ref;
        return toolParams[property];
      }).map(_ref2 => {
        let [property, styles] = _ref2;
        return {
          key: property,
          value: toolParams[property],
          ...styles
        };
      });
    },
    hasMetadataProperties() {
      return this.metadataProperties.length > 0;
    }
  },
  methods: {
    formatPropertyValue(value) {
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      if (typeof value === 'boolean') {
        return value ? translate('Yes', 'Yes') : translate('No', 'No');
      }
      return value;
    },
    processPropertyIcon(icon, propertyValue) {
      if (typeof icon === 'function') {
        return icon(propertyValue);
      }
      return icon;
    }
  },
  i18n: {
    DESCRIPTION_ACCORDION_TITLE: translate('BaseToolParams.ExpandDescriptionTitle', 'Read description'),
    EXPAND_JSON_VIEW_TITLE: translate('BaseToolParams.ExpandJsonViewTitle', 'See request parameters as JSON')
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-flex gl-flex-col gl-gap-3"},[(_vm.hasMetadataProperties)?_c('div',{staticClass:"gl-flex gl-flex-wrap gl-gap-2"},_vm._l((_vm.metadataProperties),function(property){return _c('span',{key:property.key,staticClass:"gl-overflow-hidden"},[(property.type == 'url')?_c('gl-badge',{attrs:{"icon":property.icon,"href":property.value,"title":property.value}},[_c('span',{staticClass:"gl-truncate"},[_vm._v("\n          "+_vm._s(property.value)+"\n        ")])]):_c('gl-badge',{attrs:{"icon":_vm.processPropertyIcon(property.icon, property.value)}},[_vm._v("\n        "+_vm._s(property.label)+": "+_vm._s(_vm.formatPropertyValue(property.value))+"\n      ")])],1)}),0):_vm._e(),_vm._v(" "),(_vm.message)?_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.message),expression:"message"}]}):_vm._t("default"),_vm._v(" "),(_vm.message || _vm.description)?_c('gl-accordion',{staticClass:"-gl-ml-2",attrs:{"header-level":3}},[(_vm.description)?_c('gl-accordion-item',{staticClass:"gl-mb-3",attrs:{"title":_vm.accordionTitle}},[_c('pre-block',{attrs:{"language":"markdown"}},[_vm._v(_vm._s(_vm.description))])],1):_vm._e(),_vm._v(" "),(_vm.withJsonView)?_c('gl-accordion-item',{attrs:{"title":_vm.$options.i18n.EXPAND_JSON_VIEW_TITLE}},[_c('tool-params-json-view',{attrs:{"tool-params":_vm.toolParams}})],1):_vm._e()],1):(!_vm.message && !_vm.description && _vm.withJsonView)?_c('tool-params-json-view',{attrs:{"tool-params":_vm.toolParams}}):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
